import { BarNote, Clef, ClefNote, Stave as VexStave } from 'vexflow4';
import { StaveNote } from './MusiconStaveNote';
import { DEFAULT_NOTE_STYLE } from '../constants';
import { countDuration } from '../../utils/helpers';

export default class Stave extends VexStave {
    public tickables: StaveNote[] = [];
    private beams: any[] = [];

    public setTickables = (tickables: Array<any>) => {
        this.tickables = tickables;
    };

    public getTickables = () => {
        return this.tickables;
    };

    public getRest = () => {
        let sum = 0;
        this.tickables.forEach((note) => {
            const duration = note.getDuration();
            sum += 1 / countDuration(duration);
        });

        return sum;
    };

    public getNotes = () => {
        var notes = [];

        for (var i = 0; i < this.tickables.length; i++) {
            var tickable = this.tickables[i];
            if (tickable instanceof StaveNote) notes.push(tickable);
        }

        return notes;
    };

    public insertTickableBetween = (newTickable: StaveNote, previousTickable: StaveNote | null, nextTickable: StaveNote | null) => {
        // if (this.getRest() + (1 / countDuration(newTickable.getDuration())) > 1) return;
        if (newTickable instanceof ClefNote) {
            //If the stave has no clef modifiers, then add it.
            if (this.getClefModifierIndex() < 0) {
                const clef = newTickable?.getClef();
                if (typeof clef === 'string') this.addClef(clef);
                return;
            }
            //If the stave already has a clef, but the user clicked before any other tickable, then replace the stave clef
            else if (previousTickable == null) {
                const clef = newTickable?.getClef();
                if (typeof clef === 'string') this.replaceClef(clef);
                return;
            }
            //Else add it as a normal ClefNote as long as the stave already has notes, so leave otherwise
            else if (this.getNotes().length === 0) return;
        } else if (newTickable instanceof BarNote) {
            //If the BarNote is to be inserted after everything, then modify the end bar of the stave
            if (nextTickable == null) {
                this.setEndBarType(newTickable.getType());
                return;
            }
            //Else add it as a normal BarNote as long as the stave already has notes, so leave otherwise
            else if (this.getNotes().length === 0) return;
        }

        newTickable.setStyle(DEFAULT_NOTE_STYLE);

        if (nextTickable == null) {
            this.pushTickable(newTickable);
        } else {
            const referenceIndex = this.tickables.indexOf(nextTickable);
            this.tickables.splice(referenceIndex, 0, newTickable);
        }
    };

    public getClefModifierIndex = () => {
        //Remove all clefs currently in the stave
        for (var i = 0; i < this.modifiers.length; i++) {
            var modifier = this.modifiers[i];

            if (modifier instanceof Clef) return i;
        }
        return -1;
    };

    public replaceClef = (clef: string) => {
        var start_X = this.start_x;
        this.setClef(clef);
        this.modifiers.splice(this.getClefModifierIndex(), 1);
        // this.glyphs = [];
        this.addClef(clef);

        this.start_x = start_X;
    };

    public getPreviousTickable = (referenceTickable: any) => {
        var referenceIndex = this.tickables.indexOf(referenceTickable);
        if (referenceIndex === 0) return null;
        return this.tickables[referenceIndex - 1];
    };

    public getNextTickable = (referenceTickable: StaveNote) => {
        var referenceIndex = this.tickables.indexOf(referenceTickable);
        if (referenceIndex === this.tickables.length - 1) return null;
        return this.tickables[referenceIndex + 1];
    };
    public getNextNote = (referenceNote: any) => {
        var referenceIndex = this.tickables.indexOf(referenceNote);
        while (referenceIndex < this.tickables.length) {
            referenceIndex++;
            if (this.tickables[referenceIndex] instanceof StaveNote) return this.tickables[referenceIndex];
        }

        return null;
    };

    public replaceTickable = (oldTickable: StaveNote, newTickable: StaveNote) => {
        //Replacing note in beam.
        const oldBeam = oldTickable.getBeam();
        if (oldBeam != null) {
            const beam = oldBeam;
            const referenceIndex = beam.getNotes().indexOf(oldTickable);
            beam.notes[referenceIndex] = newTickable;
        }

        const referenceIndex = this.tickables.indexOf(oldTickable);
        this.tickables[referenceIndex] = newTickable;
    };

    public removeTickable = (tickable: StaveNote) => {
        this.tickables.splice(this.tickables.indexOf(tickable), 1);
    };

    public pushTickable = (newTickable: StaveNote) => {
        this.tickables.push(newTickable);
    };
    public setBeams = (beamList: any) => {
        this.beams = beamList;
    };
    public getBeams = () => {
        return this.beams;
    };
    public pushBeam = (beam: any) => {
        this.beams.push(beam);
    };
}
